export var formatPublisherLabel = function (publisher) {
    var _a;
    var namePart = [publisher.name, publisher.nameSuffix]
        .map(function (part) { return part === null || part === void 0 ? void 0 : part.trim(); })
        .filter(Boolean)
        .join(" ");
    var qualifier = (_a = publisher.qualifier) === null || _a === void 0 ? void 0 : _a.trim();
    return qualifier ? "".concat(namePart, " (").concat(qualifier, ")").trim() : namePart;
};
